import { formatFeePercent } from "../utils/clientTransactionCharge";

const columns = [
    {
        title: 'Operation',
        dataIndex: 'operation',
        // sorter: (a, b) => a?.operation - b?.operation,
    },
    {
        title: 'Payment From',
        dataIndex: 'paymentFrom',
        // sorter: (a, b) => a?.paymentFrom?.localeCompare(b?.paymentFrom),
    },
    {
        title: 'Payment To',
        dataIndex: 'paymentTo',
        // sorter: (a, b) => a?.paymentTo?.localeCompare(b?.paymentTo),
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        // sorter: (a, b) => a?.amount - b?.amount,
    },
    {
        title: 'Fee',
        dataIndex: 'fee',
        render: (value) => formatFeePercent(value),
    },
    {
        title: 'Currency',
        dataIndex: 'currency',
        // sorter: (a, b) => a?.currency?.localeCompare(b?.currency),
    },
    {
        title: 'Transaction Date',
        dataIndex: 'transactionDate',
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    }
];

export default columns;